import { Locale } from "@ct-react/locale";

export type SingleNewField = {
  id: string,
  publishedDate: string;
  updatedDate?: string;
  data: any;
  publishedAt: string;
}

type TranslatableText = {
  languageCode: string;
  description: string;
}

const translatableText = (data: TranslatableText[] | undefined, locale: Locale): string | undefined => {
  const search = data?.find(tt => tt.languageCode.toLowerCase() === locale.basename) || undefined;
  return !!search ? search.description : undefined;
}

const translatableTextWithFallback = (data: TranslatableText[] | undefined, locale: Locale): string | undefined =>
  translatableText(data, locale)?.trim() || data?.find(tt => !!tt.description?.trim())?.description.trim();

export type CmsPageContent = Record<string, any>;

export const extractCmsContent = (data: any, locale: Locale) =>
  data.reduce((acc: CmsPageContent, { slug, type, ...others }: any) => {
    switch (type) {
      case "String":
        acc[slug] = others.text;
        break;
      case "Text":
        const text = translatableText(others.text, locale);
        if (!!text) acc[slug] = text;
        break;
      case "Html":
        const html = translatableText(others.html, locale);
        if (!!html) acc[slug] = html;
        break;
      case "Image":
        const { alternativeText: alt, assets, ...imageOthers } = others;
        const alternativeText = translatableTextWithFallback(alt, locale);
        acc[slug] = {
          ...imageOthers,
          assets: (assets ?? []).map(({ breakpoint, ...metas }: any) => ({
            ...metas,
            ...(breakpoint !== "Original") && { breakpoint },
          })),
          ...(!!alternativeText) && { alternativeText }
        };
        break;
      case "Group":
        if (others.fields.length > 0)
          acc[slug] = others.repeatable
            ? others.fields.map((fc: any) => extractCmsContent(fc, locale))
            : extractCmsContent(others.fields[0], locale)
        break;
    }
    return acc;
  }, {});

